/**
 * Parallax Position
 *
 * @author Space-Time Inc.
 * @version 2022-11-11
 */
/**
 * Script for All Pages
 *
 * @author Space-Time Inc.
 * @version 2022-11-14
 */

/**
 * Minimum Viewport (JS)
 *
 * @author Space-Time Inc.
 * @version 2022-07-11
 */

(() => {
	const MIN_WIDTH = 360;

	const vp = document.querySelector('meta[name="viewport"]');
	function fn() {
		const v = window.outerWidth > MIN_WIDTH ? 'width=device-width,initial-scale=1' : `width=${MIN_WIDTH}`;
		if (vp.getAttribute('content') !== v) {
			vp.setAttribute('content', v);
		}
	}
	addEventListener('resize', throttle(fn), false);
	fn();

	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
})();

/**
 * Back To Top
 *
 * @author Takuto Yanagida
 * @version 2022-07-09
 */

(() => {
	function init() {
		const OFFSET_Y = 0;

		const btn = document.getElementById('back-to-top');
		if (btn === null) return;
		const ph  = btn.parentElement;

		onScroll(scrollHandler);
		onResize(scrollHandler);
		if ('ontouchstart' in window) window.addEventListener('touchmove', scrollHandler);
		setTimeout(scrollHandler, 100);

		function scrollHandler() {
			// const btnR = btn.getBoundingClientRect();
			// const btnH = (btnR.bottom - btnR.top);

			const viewBottomY = window.innerHeight + OFFSET_Y/* - btnH*/;
			const footerTopY = ph.getBoundingClientRect().top;

			if (viewBottomY > footerTopY) {
				btn.style.transform = 'translateY(-' + (viewBottomY - footerTopY) + 'px)';
				btn.classList.remove('fixed');
			} else {
				btn.style.transform = '';
				btn.classList.add('fixed');
			}

			if (window.pageYOffset > window.innerHeight / 3) {
				btn.classList.remove('hidden');
			} else {
				btn.classList.add('hidden');
			}
		}
	}


	// -------------------------------------------------------------------------


	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}

	const resizeListeners = [];
	const scrollListeners = [];

	function onResize(fn, doFirst = false) {
		if (doFirst) fn();
		resizeListeners.push(throttle(fn));
	}

	function onScroll(fn, doFirst = false) {
		if (doFirst) fn();
		scrollListeners.push(throttle(fn));
	}

	document.addEventListener('DOMContentLoaded', () => {
		window.addEventListener('resize', () => {
			for (const l of resizeListeners) l();
		}, { passive: true });
		window.addEventListener('scroll', () => {
			for (const l of scrollListeners) l();
		}, { passive: true });
	});

	init();
})();

/**
 * Toggle Button
 *
 * @author Space-Time Inc.
 * @version 2022-07-11
 */

 document.addEventListener('DOMContentLoaded', () => {

	const btns = document.querySelectorAll('.stile *[class^="button"]');

	for (let i = 0; i < btns.length; i += 1) {
		if (isToggleButton(btns[i])) setEventListener(btns[i]);
	}

	function isToggleButton(btn) {
		if (!btn.href || btn.href[btn.href.length - 1] !== '#') return false;
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		return f.classList.contains('frame') || f.classList.contains('frame-alt');
	}

	function setEventListener(btn) {
		btn.classList.add('toggle');
		initFrame(btn);
		btn.addEventListener('click', (e) => {
			if (btn.classList.contains('active')) {
				btn.classList.remove('active');
				setFrameVisible(btn, false);
			} else {
				btn.classList.add('active');
				setFrameVisible(btn, true);
			}
			e.preventDefault();
		});
	}

	function initFrame(btn) {
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		f.style.display = 'none';
		f.classList.add('hidden');
		setTimeout(() => { f.style.display = ''; }, 10);
	}

	function setFrameVisible(btn, visible) {
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		if (visible) {
			f.classList.remove('hidden');
		} else {
			f.classList.add('hidden');
		}
	}

});

/**
 * Scroll Shadow (JS)
 *
 * @author Space-Time Inc.
 * @version 2022-07-11
 */

(function () {

	const SEL_CONTAINER = '.scroll-shadow';
	const CLS_SHADOW    = 'shadow';

	document.addEventListener('DOMContentLoaded', () => {
		const cs = document.querySelectorAll(SEL_CONTAINER);
		const ss = [];
		const ps = [];
		for (let i = 0; i < cs.length; i += 1) {
			const c = cs[i];
			const s = createShadow(c);
			c.addEventListener('scroll', ST.throttle(() => { updateShadow(c, s); }));
			ST.onResize(() => { updateShadow(c, s); }, true);
			ss.push(s);
			ps.push(c.parentElement.parentElement);
		}
		const mo = new MutationObserver((ms) => {
			for (let i = 0; i < cs.length; i += 1) updateShadow(cs[i], ss[i]);
		});
		const opts = { attributes: true, childList: false, characterData: false, attributeFilter: ['class'] };
		for (let i = 0; i < ps.length; i += 1) { mo.observe(ps[i], opts); }
	});


	// -------------------------------------------------------------------------


	function createShadow(cont) {
		const r = cont.getBoundingClientRect();
		const pr = cont.parentElement.getBoundingClientRect();
		const h = (pr.bottom - pr.top === 0) ? ((r.bottom - r.top) + 'px') : '100%';

		const shadow = document.createElement('div');
		shadow.className           = CLS_SHADOW;
		shadow.style.position      = 'absolute';
		shadow.style.top           = '0';
		shadow.style.left          = '0';
		shadow.style.width         = '100%';
		shadow.style.height        = h;
		shadow.style.pointerEvents = 'none';

		const cs = getComputedStyle(cont.parentElement);
		if (cs.position !== 'relative' && cs.position !== 'absolute') cont.parentElement.style.position = 'relative';
		cont.parentElement.appendChild(shadow);
		return shadow;
	}

	function updateShadow(cont, shadow) {
		if (isScrollable(cont)) {
			shadow.style.background = calcShadowStyle(cont);
		} else {
			shadow.style.background = '';  // This must be '' for IE11
		}
	}

	function isScrollable(cont) {
		return (cont.scrollWidth - cont.clientWidth > 2);  // for avoiding needless scrolling
	}

	function calcShadowStyle(cont) {
		const r = cont.scrollLeft / (cont.scrollWidth - cont.clientWidth);
		let rl = 0.35, rr = 0.35;
		if (r < 0.1) rl *= r / 0.1;
		if (0.9 < r) rr *= (1 - r) / 0.1;
		const sl = `linear-gradient(to right, rgba(0,0,0,${rl}), rgba(0,0,0,0)) left top`;
		const sr = `linear-gradient(to left,  rgba(0,0,0,${rr}), rgba(0,0,0,0)) right top`;
		const size = ' / 1.5rem 100% no-repeat scroll';
		return sl + size + ',' + sr + size;
	}

})();

/**
 * Parallax Position
 *
 * @author Space-Time Inc.
 * @version 2022-11-11
 */

class ParallaxPosition {
	#speed    = 0.5;
	#property = '--parallax-y';

	constructor(speed = 0.5, property = '--parallax-y') {
		this.#speed    = speed;
		this.#property = property;

		/**
		 * Throttling Function
		 *
		 * @author Space-Time Inc.
		 * @version 2022-10-13
		 */
		
		function throttle(fn) {
			let isRunning;
			return (...args) => {
				if (isRunning) return;
				isRunning = true;
				requestAnimationFrame(() => {
					isRunning = false;
					fn(...args);
				});
			};
		}
		
		document.addEventListener('scroll', throttle(() => this.#onScroll()));
	}

	#onScroll() {
		const y = window.pageYOffset * this.#speed;
		document.documentElement.style.setProperty(this.#property, `${y}px`);
	}
}


document.addEventListener('DOMContentLoaded', () => {
	/**
	 * SNS Share URL
	 *
	 * @author Space-Time Inc.
	 * @version 2022-09-30
	 */
	
	 function applySnsShareUrl(targets) {
		const rs = [
			['<T>', document.title],
			['<U>', location.href],
		];
		for (const t of targets) {
			if ('A' === t.tagName) {
				let temp = t.href;
				for (const r of rs) temp = temp.replace(...r.map(encodeURIComponent));
				t.setAttribute('href', temp);
			} else if ('META' === t.tagName) {
				let temp = t.content;
				for (const r of rs) temp = temp.replace(...r);
				t.setAttribute('content', temp);
			}
		}
	}
	

	applySnsShareUrl(document.querySelectorAll('meta[property][content]'));
	applySnsShareUrl(document.querySelectorAll('.sns-share a'));

	new ParallaxPosition(0.7);
});
